import { generateArray } from '@/utils/function';

export default {
	data() {
		return {
			pagingModelName: 'pagingModel',
			pagingModel: {
				countPerPage: 0,
				items: [],
				page: 1,
				totalCount: 0,
				totalPageCount: 0
			}
		};
	},
	computed: {
		pagingModelData() {
			return this[this.pagingModelName];
		},
		hasNoMoreRecords() {
			return (
				this.hasResults &&
				this.pagingModelData.items.length ===
					this.pagingModelData.totalCount
			);
		},
		hasPagination() {
			return this.pagingModelData.totalPageCount > 1;
		},
		hasResults() {
			return this.pagingModelData.totalCount > 0;
		},
		nextPage() {
			return this.hasResults &&
				this.pagingModelData.page < this.pagingModelData.totalPageCount
				? this.pagingModelData.page + 1
				: undefined;
		},
		previousPage() {
			return this.pagingModelData.page > 1
				? this.pagingModelData.page - 1
				: undefined;
		},
		pages() {
			return generateArray(1, this.pagingModelData.totalPageCount);
		},
		resultCounter() {
			if (this.hasResults) {
				if (this.hasPagination) {
					return (
						this.pagingModelData.countPerPage +
						' of ' +
						this.pagingModelData.totalCount
					);
				} else {
					return this.pagingModelData.totalCount;
				}
			}
			return '0';
		}
	}
};
